import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import {Dashboard} from "@uppy/react";
// import Dashboard from "@uppy/react/lib/Dashboard";

import Webcam from "@uppy/webcam";
import { useEffect, useMemo } from "react";

const Upload = (props) => {
  const uppy = useMemo(() => {
    return (
      Uppy()
        .use(Webcam) // `id` defaults to "Webcam". Note: no `target` option!
        // or
        .use(Webcam, { id: "MyWebcam" }) // `id` is… "MyWebcam"
        .use(XHRUpload, {
            endpoint: "http://localhost:3000/.netlify/functions/server/api/upload/image",
            fieldName: 'photo',
            // formData: true
        })
    ); 
  }, []);

  useEffect(() => {
    return () => uppy.close();
  }, []);

  return (
    <div style={{ width: props?.width, height: props?.height }}>
      <Dashboard uppy={uppy} plugins={["Webcam"]} {...props} />
    </div>
  );
};
export default Upload;
